import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { Badge, SimpleFlexbox, InternalLink } from 'ctm-components';
import { ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';
import { getFormValue } from '../../core/state_selectors';
import { useStyles } from './car_badge_button_group_styles';

const _CarBadgeButtonGroup = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { formValue, updateStatesResetValues } = props;

    let badgesArray = [];
    if (props.badges) {
        badgesArray = JSON.parse(JSON.stringify(props.badges));
    }

    /**
     * Render the component.
     * @returns {Node} - return the the badge radio button group component. This is a custom component
     * that mimics the look of the radio button group but removes the NO_BADGE option.
     */
    return (
        <SimpleFlexbox className={classes.badge_button_group}>
            {badgesArray.map((badge) => (badge.code === 'NO_BADGE' ? null : (
                <InternalLink
                    className={classes.badge_button_link}
                    data-id={`car_badge_${badge.code}`}
                    onClick={() => updateStatesResetValues(badge.code)}
                    href="/car-insurance/journey/car_series"
                    key={badge.code}
                >
                    <Badge
                        id={badge.code}
                        key={badge.code}
                        optionProps={{
                            innerLabel: badge.label,
                            value: badge.code
                        }}
                        schema={{
                            identifier: 'coverDetail.vehicle.badge',
                            stateKey: 'vertical.quote.apiResponses.badge.code',
                            field: {
                                type: 'badgegroup',
                                metaType: 'radio',
                                UIComponent: 'badge_primary_semi_rounded',
                                labelVariant: 'inner_label_container_small_align_center',
                                values: {
                                    stateKey: 'vertical.quote.apiResponses.badge',
                                    labelType: 'innerLabel',
                                    labelKey: 'label',
                                    valueKey: 'code'
                                }
                            }
                        }}
                        value={formValue}
                    />
                </InternalLink>
            ))
            )}
        </SimpleFlexbox>
    );
};

const mapStateToProps = (state) => {
    // eslint-disable-next-line radix
    const badges = state.getIn(['vertical', 'quote', 'apiResponses', 'badge']);
    const formValue = getFormValue(state, 'coverDetail.vehicle.badge');
    return { badges, formValue };
};

const mapDispatchToProps = (dispatch) => ({
    updateStatesResetValues: (code) => {
        dispatch({
            type: 'SET_FORM_VALUE',
            value: code,
            stateKey: 'vertical.quote',
            identifier: 'coverDetail.vehicle.badge'
        });
        dispatch({
            type: 'RESET_VALUES',
            stateKey: 'vertical.quote',
            identifiers: [
                'coverDetail.vehicle.colour',
                'coverDetail.vehicle.redbookCode',
                'coverDetail.vehicle.redbookCodeLong',
                'coverDetail.vehicle.nviCode',
                'coverDetail.vehicle.glassCode',
                'coverDetail.vehicle.marketValue',
                'coverDetail.vehicle.alarmFitted',
                'coverDetail.vehicle.immobiliserFitted',
                'coverDetail.vehicle.securityFeatures',
                'coverDetail.vehicle.factoryOptions',
                'coverDetail.vehicle.nonStandardAccessories'
            ]
        });
        dispatch({
            type: 'RESET_TOUCHES',
            stateKey: 'vertical.quote',
            identifiers: ['coverDetail.vehicle.redbookCode']
        });
    }
});

_CarBadgeButtonGroup.propTypes = {
    dispatch: PropTypes.func
};

const CarBadgeButtonGroup = connect(
    mapStateToProps,
    mapDispatchToProps
)(_CarBadgeButtonGroup);

export { _CarBadgeButtonGroup, CarBadgeButtonGroup };
